<template lang="html">
  <div id="thanks-page">

    <section class="main-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 col-content">
            <div class="mt-4 box-white">
              <div class="check-animation">
                <div class="success-checkmark">
                  <div class="check-icon">
                    <span class="icon-line line-tip"></span>
                    <span class="icon-line line-long"></span>
                    <div class="icon-circle"></div>
                    <div class="icon-fix"></div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-lg-10 text-center">
                  <h2 class="f-w-700 title">¡Gracias!</h2>

                  <h5 class="mt-3">Se ha registrado en la plataforma correctamente.
                    <!-- Revise su correo para confirmar su cuenta. -->
                  </h5>
                  <br />
                  <p>
                    <router-link to="/"><i class="fas fa-home-lg-alt"></i> <b class="f-w-600">Regresar al inicio</b></router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
